import { createReducer, on } from '@ngrx/store';
import { EnergyStarAccount } from '../../model/energy-star-account.model';
import * as EnergyStarAccountActions from '../actions/energy-star-account.action';

export interface EnergyStarAccountState {
  accounts: EnergyStarAccount[];
  loading: boolean;
  error: any;
  errorMessage: string | null;
  createLoading: boolean;
  updateLoading: boolean;
}

export const initialState: EnergyStarAccountState = {
  accounts: [],
  loading: false,
  error: null,
  errorMessage: null,
  createLoading: false,
  updateLoading: false,
};

export const reducer = createReducer(
  initialState,

  on(
    EnergyStarAccountActions.loadEnergyStarAccounts,
    (state): EnergyStarAccountState => ({
      ...state,
      loading: true,
      error: null,
    }),
  ),
  on(
    EnergyStarAccountActions.loadEnergyStarAccountsSuccess,
    (state, { accounts }): EnergyStarAccountState => ({
      ...state,
      accounts,
      loading: false,
      error: null,
    }),
  ),
  on(
    EnergyStarAccountActions.loadEnergyStarAccountsFailure,
    (state, { error }): EnergyStarAccountState => ({
      ...state,
      loading: false,
      error,
    }),
  ),

  on(
    EnergyStarAccountActions.createEnergyStarAccount,
    (state): EnergyStarAccountState => ({
      ...state,
      createLoading: true,
      error: null,
      errorMessage: null,
    }),
  ),
  on(
    EnergyStarAccountActions.createEnergyStarAccountSuccess,
    (state, { account }): EnergyStarAccountState => ({
      ...state,
      accounts: [...state.accounts, account],
      createLoading: false,
      error: null,
      errorMessage: null,
    }),
  ),
  on(
    EnergyStarAccountActions.createEnergyStarAccountFailure,
    (state, { error, errorMessage }): EnergyStarAccountState => ({
      ...state,
      createLoading: false,
      error,
      errorMessage,
    }),
  ),

  on(
    EnergyStarAccountActions.updateEnergyStarAccount,
    (state): EnergyStarAccountState => ({
      ...state,
      updateLoading: true,
      error: null,
    }),
  ),
  on(
    EnergyStarAccountActions.updateEnergyStarAccountSuccess,
    (state, { account }): EnergyStarAccountState => ({
      ...state,
      accounts: state.accounts.map(acc => (acc.id === account.id ? account : acc)),
      updateLoading: false,
      error: null,
    }),
  ),
  on(
    EnergyStarAccountActions.updateEnergyStarAccountFailure,
    (state, { error }): EnergyStarAccountState => ({
      ...state,
      updateLoading: false,
      error,
    }),
  ),
);

export default EnergyStarAccountState;
